// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"101\" height=\"101\" viewBox=\"0 0 101 101\"><defs><style>.a{fill:#ee1515}</style></defs><g transform=\"translate(-137 -154)\"><circle class=\"a\" cx=\"50.5\" cy=\"50.5\" r=\"50.5\" transform=\"translate(137 154)\"/></g></svg>";
// Exports
module.exports = code;